import { Route } from "../../../security/route";
import EditorOverView from "../editor-overview/editorOverview";
import LandingPage from "../landing-page/landing-page";
import RegisterPage from "../register/register";

export const routes: Route[] = [
  { path: "/", Component: LandingPage, exact: true },
  { path: "/signup", Component: RegisterPage, exact: true },
  { path: "/overview/:id", Component: EditorOverView, exact: true },
];
